import React from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '../../../common';

import styles from './TermsAndConditionCareCredit.module.css';

export const TermsAndConditionCareCredit = ({
  selected = false,
  onChange = () => { },
}) => {
  const { t } = useTranslation('fileClaimbot');

  return (
    <div className={styles.mainContainer}>
      <span>{t('termsConditionCareCredit.termsDescription')}</span>

      <Checkbox
        checked={selected}
        label={t('termsConditionCareCredit.checkboxLabel')}
        onChange={onChange}
      />
    </div>
  );
};
